import React from 'react'
import { Input, Button } from 'antd'
import styles from './EditorCommon.module.css'

const ListEditor = ({ items = [], onChange, onAdd, onRemove, placeholder = 'Enter item', addButtonLabel = '+ Add Item' }) => {
  return (
    <>
      {items.map((item, index) => (
        <div key={index} className={styles.listItemRow}>
          <Input
            value={item}
            onChange={e => onChange(index, e.target.value)}
            placeholder={placeholder}
          />
          <Button
            danger
            onClick={() => onRemove(index)}
            style={{ marginLeft: '8px' }}
          >
            Remove
          </Button>
        </div>
      ))}
      <Button
        type="dashed"
        onClick={onAdd}
        style={{ width: '100%', marginTop: '8px', marginBottom: '12px' }}
      >
        {addButtonLabel}
      </Button>
    </>
  )
}

export default ListEditor
